<template>
  <div ref="pdfContent" class="pdf-content">
    <CCard class="border-0">
      <CCardHeader v-if="!hideControls" class="no-print bg-transparent">
        <div class="float-right">
          <a href="#" class="btn btn-sm btn-info ml-1" @click="printContent">
            <CIcon name="cil-print" class="mr-1" /> Print
          </a>
        </div>
      </CCardHeader>
      <CCardBody>
        <div class="header">
          <CRow class="align-items-start mb-3">
            <CCol cols="3" md="2" class="text-left">
              <img
                :src="getImageUrl()"
                alt="Logo Syarikat"
                class="logo-image"
              />
            </CCol>
            <CCol cols="9" md="10" class="text-right company-info">
              <h1 class="company-name">{{ company.name }}</h1>
              <p class="company-tagline">{{ company.tagLine }}</p>
              <p class="company-regno">{{ "(" + company.regNo + ")" }}</p>
              <p class="company-address" v-html="formatAddress(company.address)"></p>
              <p class="company-phone">Tel: {{ company.phone }}</p>
            </CCol>
          </CRow>
          <hr class="thick-hr" />
        </div>
        <div class="invoice-header">
          <h3 class="text-center">INVOICE</h3>
          <CRow>
            <CCol md="6">
              <p><strong>To Customer:</strong></p>
              <p>{{ getLoanBankName() }}</p>
              <p v-html="formatAddress(getLoanBankAddress())"></p>
            </CCol>
            <CCol md="6" class="text-right">
              <p><strong>Invoice No:</strong> {{ stock.stockNo }}</p>
              <p><strong>Date:</strong> {{ getRegistrationDate() }}</p>
              <p><strong>D.O No:</strong> <label>___________</label></p>
              <p><strong>P.O No:</strong> <label>___________</label></p>
              <p><strong>Salesman:</strong> <label>___________</label></p>
            </CCol>
          </CRow>
        </div>
        <div class="invoice-details">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Qty</th>
                <th>Particulars</th>
                <th class="text-right">Unit Price</th>
                <th class="text-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1 Case</td>
                <td>
                  <p>HIRER NAME: {{ getCustomerName() }}</p>
                  <p>
                    VEHICLE MODEL: {{ brandName }} -
                    {{ modelName }}
                  </p>
                  <p>
                    REGN. NO: {{ stock.registration?.vehicleRegistrationNumber || 'N/A' }}
                  </p>
                </td>
                <td class="text-right">{{ formatMoney((stock.sale?.eoeAmount || 0).toFixed(2)) }}</td>
                <td class="text-right">{{ formatMoney((stock.sale?.eoeAmount || 0).toFixed(2)) }}</td>
              </tr>
              <tr>
                <td>Ringgit</td>
                <td colspan="3">
                  {{ getEoeAmountInWords() }}
                </td>
              </tr>

              <tr>
                <td colspan="2"><strong>E. & O. E.</strong></td>
                <td class="text-right"><strong>Total</strong></td>
                <td class="text-right">
                  <strong>{{ formatMoney((stock.sale?.eoeAmount || 0).toFixed(2)) }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="invoice-footer">
          <br />
          <br />
          <br />
          <br />
          <div class="signature text-right">
            <p>For {{ company.name }}</p>
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "WidgetsReportEoeInvoice",
  props: {
    company: {
      type: Object,
      required: true,
      validator: (value) => {
        return ["name", "tagLine", "address", "phone", "logoUrl"].every(
          (prop) => prop in value
        );
      },
    },
    stock: {
      type: Object,
      required: true,
    },
    bank: {
      type: Object,
      required: true,
    },
    hideControls: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.forceA4Size();
  },
  computed: {
    brandName() {
      try {
        return this.stock.vehicle.brand.name;
      } catch (error) {
        return "N/A";
      }
    },
    modelName() {
      try {
        return this.stock.vehicle.model.name;
      } catch (error) {
        return "N/A";
      }
    },
  },
  methods: {
    formatMoney(value) {
      // Convert to number and format with commas
      const num = parseFloat(value);
      if (isNaN(num)) return "0.00";
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    forceA4Size() {
      const pdfContent = this.$refs.pdfContent;
      if (pdfContent) {
        pdfContent.style.width = "210mm";
      }
    },
    getCustomerName() {
      try {
        return this.stock.sale.customer.name;
      } catch (error) {
        return "N/A";
      }
    },
    getEoeAmountInWords() {
      var num = this.stock.sale?.eoeAmount || 0;
      const belowTwenty = [
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
      ];

      const tens = [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
      ];

      const aboveHundred = ["", "thousand", "million", "billion", "trillion"];

      function helper(n) {
        if (n < 20) return belowTwenty[n];
        else if (n < 100)
          return (
            tens[Math.floor(n / 10)] +
            (n % 10 === 0 ? "" : " " + belowTwenty[n % 10])
          );
        else
          return (
            belowTwenty[Math.floor(n / 100)] +
            " hundred" +
            (n % 100 === 0 ? "" : " " + helper(n % 100))
          );
      }

      if (num === 0) return "ZERO";

      let word = "";
      let i = 0;

      while (num > 0) {
        const currentPart = num % 1000;
        if (currentPart !== 0) {
          word =
            helper(currentPart) +
            (aboveHundred[i] === "" ? "" : " " + aboveHundred[i]) +
            (word === "" ? "" : " " + word);
        }
        num = Math.floor(num / 1000);
        i++;
      }

      return word.trim().toUpperCase();
    },
    getRegistrationDate() {
      try {
        const raw = this.stock && this.stock.registration && this.stock.registration.vehicleRegistrationDate;
        if (!raw) return "-";
        const d = new Date(raw);
        if (isNaN(d.getTime())) return "-";
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return "-";
      }
    },

    getLoanBankAddress() {
      try {
        return this.bank.address;
      } catch (error) {
        return "N/A";
      }
    },
    getLoanBankName() {
      try {
        return this.bank.name;
      } catch (error) {
        return "N/A";
      }
    },

    formatAddress(address) {
      if (!address) return "";
      return address.replace(/\n/g, "<br />");
    },

    removeTrailingSlash(str) {
      if (str.endsWith("/")) {
        return str.slice(0, -1);
      }
      return str;
    },
    getImageUrl() {
      var url = this.removeTrailingSlash(apiUrl) + this.company.logoUrl;
      console.log(url);
      return url;
    },
    getStampUrl() {
      var url = apiUrl + this.company.stampUrl;
      return url;
    },
    saveAsPDF() {
      const element = this.$refs.pdfContent;
      const options = {
        margin: [0.5, 0.5, 0.5, 0.5], // Top, right, bottom, left
        filename: "Invoice.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().from(element).set(options).save();
    },
    printContent() {
      const printContents = this.$refs.pdfContent.innerHTML;
      const originalContents = document.body.innerHTML;

      document.body.innerHTML = printContents;

      window.print();

      document.body.innerHTML = originalContents;
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.thick-hr {
  border: 1px solid #000;
  margin: 10px 0;
}

.pdf-content {
  width: 210mm;
  max-width: 100%;
  margin: 0 auto;
  padding: 15mm;
  box-sizing: border-box;
  background-color: white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.4;
  color: #333;
}

.logo-image {
  max-width: 120px;
  height: auto;
  display: block;
}

.stamp-image {
  max-width: 100px;
  max-height: 100px;
}

.header {
  page-break-after: avoid;
  page-break-inside: avoid;
  margin-bottom: 15px;
}

.company-info {
  padding-left: 15px;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
  line-height: 1.2;
}

.company-tagline,
.company-regno,
.company-address,
.company-phone {
  margin-bottom: 3px;
  font-size: 11px;
  line-height: 1.3;
}

.invoice-header {
  page-break-inside: avoid;
  margin-bottom: 20px;
}

.invoice-details {
  page-break-inside: avoid;
  margin-bottom: 20px;
}

.table {
  width: 100%;
  page-break-inside: auto;
  border-collapse: collapse;
}

.table thead {
  page-break-after: avoid;
}

.table tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

.table th,
.table td {
  padding: 6px 8px;
  line-height: 1.2;
  height: 30px;
}

.table td p {
  margin: 0;
  line-height: 1.2;
  min-height: 1.2em;
}

.table td p:empty::before {
  content: '\00a0';
}

.invoice-footer {
  page-break-inside: avoid;
  margin-top: 20px;
}

.invoice-footer p,
.signature p {
  margin: 0;
}

.signature {
  page-break-inside: avoid;
  margin-top: 30px;
}

@media print {
  .no-print {
    display: none !important;
  }

  .pdf-content {
    width: 794px;
    margin: 0;
    padding: 20px;
    box-shadow: none;
  }

  .pdf-content .card {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .pdf-content .card-body {
    padding: 0 !important;
  }

  .logo-image {
    max-width: 100px !important;
  }

  .company-name {
    font-size: 18px !important;
  }

  body {
    background: white;
  }

  .table {
    font-size: 11px;
  }

  .table th,
  .table td {
    padding: 5px 8px;
    line-height: 1.1;
    height: 28px;
  }

  .table td p {
    margin: 0;
    line-height: 1.1;
    min-height: 1.1em;
  }

  .table td p:empty::before {
    content: '\00a0';
  }
}

/* PDF Generation specific styles */
.pdf-content.pdf-generation {
  width: 794px !important;
  padding: 0 !important;
  margin: 0;
}

.pdf-content.pdf-generation .card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

.pdf-content.pdf-generation .card-body {
  padding: 0 !important;
}

.pdf-content.pdf-generation .no-print {
  display: none !important;
}

.pdf-content.pdf-generation .logo-image {
  max-width: 100px !important;
}

.pdf-content.pdf-generation .company-name {
  font-size: 18px !important;
}

.pdf-content.pdf-generation .table {
  width: 100%;
  font-size: 11px;
}

.pdf-content.pdf-generation .table th,
.pdf-content.pdf-generation .table td {
  padding: 5px 8px;
  line-height: 1.1;
  height: 28px;
}

.pdf-content.pdf-generation .table td p {
  margin: 0;
  line-height: 1.1;
  min-height: 1.1em;
}

.pdf-content.pdf-generation .table td p:empty::before {
  content: '\00a0';
}
</style>
